import { useIsActiveLoyalty } from 'checkout/loyalty/utils/hooks';
import { numberWithCommas } from 'common/helpers/numberHelper';
import { useLocalization } from 'redux/localization/utils/hooks';

const LoyaltyPointsEarned = (props) => {
  const { cartOrOrder } = props;
  const { t } = useLocalization();
  const isLoyaltyActive = useIsActiveLoyalty();

  const { loyaltyPointsEarned } = cartOrOrder;

  if (!loyaltyPointsEarned || !isLoyaltyActive) return null;

  return (
    <div className="c7-order-summary__item--notes">
      <div>
        {numberWithCommas(loyaltyPointsEarned)}{' '}
        {t('general.loyalty.pointsEarned')}
      </div>
    </div>
  );
};

export default LoyaltyPointsEarned;
